const BASE_URL = process.env.REACT_APP_API_BASE || "http://localhost:5000/api/v1";


export const API_ROUTES = {
  SIGN_IN: `${BASE_URL}/users/me`,
  SIGN_UP: `${BASE_URL}/users/me`,
  ONBOARDING_UPDATE: `${BASE_URL}/users/me`,
  SETTINGS_UPDATE: `${BASE_URL}/users/settings`,
  GET_PLANS: `${BASE_URL}/plans`,
  CREATE_SUBSCRIPTION: `${BASE_URL}/subscription/create`,
  GET_MY_INVOICES: `${BASE_URL}/invoices/my`,
  PROJECTS: `${BASE_URL}/projects`,


  // 👷 Labor Module
  CREATE_WORKER: `${BASE_URL}/labor`,
  GET_WORKERS_BY_PROJECT: (projectId) => `${BASE_URL}/labor/project/${projectId}`,
  GET_WORKER_BY_ID: (workerId) => `${BASE_URL}/labor/${workerId}`,
  UPDATE_WORKER: (workerId) => `${BASE_URL}/labor/${workerId}`,
  DELETE_WORKER: (workerId) => `${BASE_URL}/labor/${workerId}`,

  MARK_ATTENDANCE_BULK: `${BASE_URL}/labor/attendance/bulk`,
  MARK_ATTENDANCE_INDIVIDUAL: (workerId) => `${BASE_URL}/labor/attendance/${workerId}`,
  GET_WORKER_ATTENDANCE: (workerId) => `${BASE_URL}/labor/attendance/${workerId}`,
  FETCH_ATTENDANCE_BY_DATE: (projectId, date) => `${BASE_URL}/labor/attendance/project/${projectId}/date/${date}`,

  LOG_PAYMENT: (workerId) => `${BASE_URL}/labor/payment/${workerId}`,
  GET_WORKER_PAYMENTS: (workerId, projectId) =>
    `${BASE_URL}/labor/payment/${workerId}${projectId ? `?projectId=${projectId}` : ''}`,




  // 📊 Labor Dashboard Summary & Outstanding
  GET_LABOR_SUMMARY: (projectId) => `${BASE_URL}/labor/project/${projectId}/summary`,
  GET_OUTSTANDING_WORKERS: (projectId) => `${BASE_URL}/labor/project/${projectId}/outstanding`,
  GET_RECENT_LABOR_ACTIVITY: (projectId) => `${BASE_URL}/labor/${projectId}/recent`,


  // 📦 Material Module (Clean and Correct)
  GET_MATERIALS_BY_PROJECT: (projectId) => `${BASE_URL}/materials/project/${projectId}`,
  CREATE_MATERIAL: `${BASE_URL}/materials/create`,
  UPLOAD_MATERIAL_BILL: (id) => `${BASE_URL}/materials/${id}/bill`,

  RECEIVE_MATERIAL: (id) => `${BASE_URL}/materials/${id}/receive`,
  LOG_MATERIAL_USAGE: (id) => `${BASE_URL}/materials/${id}/log-usage`,
  UNDO_MATERIAL_USAGE: (materialId) => `${BASE_URL}/materials/usage/${materialId}/undo`,
  UNDO_MATERIAL_RECEIVE: (materialId) => `${BASE_URL}/materials/${materialId}/undo-last-receive`,


  GET_MATERIAL_BY_ID: (id) => `${BASE_URL}/materials/${id}/details`,
  // 📊 Overview (new)
  GET_MATERIAL_OVERVIEW: (projectId) => `${BASE_URL}/materials/project/${projectId}/material-overview`,

  EDIT_MATERIAL: (id) => `${BASE_URL}/materials/${id}/edit`,

  GET_PROJECT_ACTIVITY: (projectId, qs = '') =>
    `${BASE_URL}/materials/project/${projectId}/material-activity${qs ? `?${qs}` : ''}`,



  // 🗑️ Delete / ♻️ Restore / 💣 Hard-delete
  DELETE_MATERIAL: (id) => `${BASE_URL}/materials/${id}`,
  RESTORE_MATERIAL: (id) => `${BASE_URL}/materials/${id}/restore`,
  HARD_DELETE_MATERIAL: (id) => `${BASE_URL}/materials/${id}/hard`,







  // Expense
  // Expense module
  GET_EXPENSES_BY_PROJECT: (projectId) => `${BASE_URL}/expenses/project/${projectId}`,
  CREATE_EXPENSE: `${BASE_URL}/expenses/create`,
  GET_EXPENSE_BY_ID: (id) => `${BASE_URL}/expenses/${id}/details`,
  EDIT_EXPENSE: (id) => `${BASE_URL}/expenses/${id}/edit`,
  DELETE_EXPENSE: (id) => `${BASE_URL}/expenses/${id}/delete`,

  UPLOAD_EXPENSE_BILL: (id) => `${BASE_URL}/expenses/${id}/bill`,
  DELETE_EXPENSE_BILL: (id) => `${BASE_URL}/expenses/${id}/bill`,

  GET_EXPENSE_OVERVIEW: (projectId) => `${BASE_URL}/expenses/project/${projectId}/overview`,
  GET_EXPENSE_REPORT: (projectId, qs = '') =>
    `${BASE_URL}/expenses/project/${projectId}/report${qs ? `?${qs}` : ''}`,

  // 📜 Expense activity (cursor)
  GET_EXPENSE_ACTIVITY: (projectId, qs = '') =>
    `${BASE_URL}/expenses/project/${projectId}/activity${qs ? `?${qs}` : ''}`,


  // 📝 Daily Logs
  CREATE_DAILY_LOG: `${BASE_URL}/daily-logs`, // POST
  GET_DAILY_LOGS: (projectId, qs = '') =>
    `${BASE_URL}/daily-logs/project/${projectId}${qs ? `?${qs}` : ''}`,
  DELETE_DAILY_LOG: (id) => `${BASE_URL}/daily-logs/${id}`,


  // Overview
  OVERVIEW: `${BASE_URL}/overview`,


  // 🔔 Notifications (must include BASE_URL)
  NOTIFICATIONS: `${BASE_URL}/notifications`,
  NOTIFICATIONS_UNREAD_COUNT: `${BASE_URL}/notifications/unread-count`,
  NOTIFICATION_READ: (id) => `${BASE_URL}/notifications/${id}/read`,
  NOTIFICATION_DELETE: (id) => `${BASE_URL}/notifications/${id}`,
  NOTIFICATIONS_MARK_ALL: `${BASE_URL}/notifications/mark-all-read`,

  // 🆕 Whats New
  WHATS_NEW_PUBLIC: `${BASE_URL}/whats-new/public`,
  WHATS_NEW_ADMIN: `${BASE_URL}/whats-new`,

  // ✅ Contact Us
  SUPPORT_CONTACT: `${BASE_URL}/support/contact`,





  GENERATE_REPORT: `${BASE_URL}/reports`,
  PROJECT_REPORT: `${BASE_URL}/reports`,

};
